import { combineSlices } from '@reduxjs/toolkit';
import { inkFinderSlice } from './inkFinder/redux';
import { searchSlice } from './search/redux';
import { skuListSlice } from './skuList/redux';
import { suggestionsSlice } from './suggestions/redux';

export const catalogReducer = combineSlices(
  inkFinderSlice,
  searchSlice,
  skuListSlice,
  suggestionsSlice,
);
